import styled from 'styled-components';
import colours from 'theme/atoms/colours';
import { NoteCaptureCard } from './shared.style';

export const Card = styled(NoteCaptureCard)`
  position: relative;
`;

export {
  ConfirmationContent as ContentSection,
  ConfirmationMessage as Description,
  ConfirmationButtons as ButtonSection,
} from './shared.style';

export const CloseButton = styled.button`
  position: absolute;
  top: 20px;
  right: 20px;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${colours.neutral[200]};
  padding: 0;

  svg {
    width: 18px;
    height: 18px;
    stroke: ${colours.neutral[900]};
    stroke-width: 2;
  }
`;
